export class MenuFuncion {
    constructor(
        public readonly Codigo: string | null,
        public readonly Nombre: string | null,
        public readonly Orden: string | null,
        public  Visible: boolean,
        public readonly MenuPadreId: number | null,
        public readonly MenuPadre: MenuFuncion | null,
        public readonly Link: string | null,
        public readonly Icono: string | null,
        public readonly MaxRolTipoId: number | null,
        public  Activo: boolean,
        public readonly Id: number,
        public readonly TieneHijos: boolean | null,
        public  MenuHijos: MenuFuncion[],
        public readonly Tenants: MenuFuncionTenant[]
    ){}
}
​
export class SearchMenuFuncionRequestDto {
    constructor(
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,
        public readonly Codigo: string | null,
        public readonly Nombre: string | null,
        public readonly RolId: number | null,
        public readonly MenuPadreId: number | null,
        public readonly VerSoloActivos: boolean | null,
        public readonly VerSoloPertenecientesAlTenant: boolean | null
    ){}
}
​
export class SearchMenuFuncionResponseDto {
    constructor(
        public readonly count: number,
        public readonly result: SearchMenuFuncionItemDto[]
    ){}
}
​
export class SearchMenuFuncionItemDto {
    constructor(
        public readonly Codigo: string | null,
        public readonly Nombre: string | null,
        public readonly Orden: string | null,
        public readonly Visible: boolean,
        public readonly MenuPadreId: number | null,
        public readonly MenuPadreCodigo: string | null,
        public readonly MenuPadreNombre: string | null,
        public readonly Link: string | null,
        public readonly Icono: string | null,
        public readonly Activo: boolean,
        public readonly Id: number
    ){}
}
​
export class SaveMenuFuncionDto {
    constructor(
        public readonly Codigo: string | null,
        public readonly Nombre: string | null,
        public readonly Orden: string | null,
        public readonly Visible: boolean | null,
        public MenuPadreId: number | null,
        public readonly Link: string | null,
        public readonly Icono: string | null,
        public readonly Activo: boolean,
        public readonly Id: number,
        public readonly MaxRolTipoId: number | null,
        public readonly Tenants: MenuFuncionTenant[]
    ){}
}

export class MenuFuncionTenant {
    constructor(
        public readonly Id: string | null,
        public Nombre: string | null,
        public Orden: string | null,
        public Icono: string | null,
        public readonly MenuFuncionId: number,
        public readonly MenuFuncionCodigo: string | null,
        public readonly MenuFuncionNombre: string | null,
        public readonly TenantId: number,
        public readonly TenantNombre: string | null,
        public Asociado: boolean
    ){}
}
